
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ResidentialService from "../pages/services/residential/page";
import CommercialService from "../pages/services/commercial/page";
import LaundryService from "../pages/services/laundry/page";
import DeliveryService from "../pages/services/delivery/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services/residential",
    element: <ResidentialService />,
  },
  {
    path: "/services/commercial",
    element: <CommercialService />,
  },
  {
    path: "/services/laundry",
    element: <LaundryService />,
  },
  {
    path: "/services/delivery",
    element: <DeliveryService />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
